import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "result_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "満足度評価入力", -1);
const _hoisted_5 = { key: 0 };
const _hoisted_6 = ["textContent"];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_9 = { class: "rank_bar" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("br", { class: "sp2" }, null, -1);
const _hoisted_12 = { key: 1 };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("br", { class: "sp2" }, null, -1);
const _hoisted_14 = { key: 2 };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("br", { class: "sp2" }, null, -1);
const _hoisted_16 = { key: 3 };
const _hoisted_17 = { class: "comment_box" };
const _hoisted_18 = { class: "inner" };
const _hoisted_19 = { class: "prof" };
const _hoisted_20 = { class: "ph" };
const _hoisted_21 = { class: "name" };
const _hoisted_22 = { class: "ca_1" };
const _hoisted_23 = { class: "ca_2" };
const _hoisted_24 = {
    class: "q_word",
    style: { "white-space": "pre-line" }
};
const _hoisted_25 = { class: "a_lead" };
const _hoisted_26 = ["onSubmit"];
const _hoisted_27 = { class: "comment_box box2" };
const _hoisted_28 = { class: "inner" };
const _hoisted_29 = { class: "prof" };
const _hoisted_30 = { class: "left" };
const _hoisted_31 = { class: "ca_1" };
const _hoisted_32 = { class: "ca_2" };
const _hoisted_33 = { class: "right" };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = { class: "ph" };
const _hoisted_36 = { class: "w_box" };
const _hoisted_37 = { class: "word" };
const _hoisted_38 = { class: "opinion" };
const _hoisted_39 = { class: "rank" };
const _hoisted_40 = ["onUpdate:modelValue", "value", "id", "name"];
const _hoisted_41 = ["for", "onClick", "onDblclick"];
const _hoisted_42 = { key: 0 };
const _hoisted_43 = { key: 1 };
const _hoisted_44 = { key: 2 };
const _hoisted_45 = ["onUpdate:modelValue", "id", "oninput"];
const _hoisted_46 = {
    key: 0,
    class: "err"
};
const _hoisted_47 = { class: "bt_box" };
const _hoisted_48 = {
    key: 0,
    class: "err"
};
const _hoisted_49 = ["onClick"];
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "submit",
        id: "submit-button",
        class: "bt_next"
    }, "次へ")
], -1);
import { reactive, computed, onBeforeMount, onMounted, onUnmounted } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import ImageFrame from '@component/ImageFrame.vue';
import { isObjEmpty } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'result_entry',
    props: {
        common: null,
        errors: null,
        id: null,
        user: null,
        question_type: null,
        subject: null,
        answer_count: null,
        reward_amount: null,
        mentors: null
    },
    setup(__props) {
        const props = __props;
        const validate = reactive({ shot: false });
        const form = InertiaUtil.getForm({
            results: [],
        }, props.common.path);
        const showRankCount = computed(() => {
            return props.answer_count < 3 ? props.answer_count : 3;
        });
        const onInputComment = (event) => {
            var _a, _b, _c, _d;
            const comment = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
            if (Alert.charLimitTextArea(comment)) {
                if ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.value) {
                    event.target.value = comment.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
                }
            }
            PageExitConfirm.addEvent();
        };
        const onClickUserProfile = (id) => {
            Inertia.get(route('user.show', { id: id }));
        };
        const onClickReturn = () => {
            window.history.back();
        };
        const onClickRank = (rank) => {
            // Check Duplicate
            form.results.forEach((result, index) => {
                if (result.rank === rank) {
                    onClickResetRank(index);
                }
            });
        };
        const onClickResetRank = (index) => {
            form.results[index].rank = null;
            const name = `rank_${index === null || index === void 0 ? void 0 : index.toString()}`;
            // 全てのチェックを外す
            const radio = document.getElementsByName(name);
            radio.forEach((el) => {
                el.checked = false;
            });
        };
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('rank.verify', { question_id: props.id }), () => { validate.shot = true; });
        };
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            form.results.forEach((_, index) => {
                resizeTextarea(index, 1);
            });
        });
        onBeforeMount(() => {
            var _a;
            // 評価入力の初期化
            if (form.results.length === 0) {
                const answerOnce = props.answer_count === 1;
                (_a = props.mentors) === null || _a === void 0 ? void 0 : _a.forEach((value) => {
                    form.results.push({
                        answer_id: value.answer.id,
                        rank: answerOnce ? 1 : null,
                        comment: '',
                    });
                });
            }
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("p", null, [
                                _createTextVNode(" 相談を終了します。 "),
                                (_unref(showRankCount) != 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _createTextVNode(" 評価の高かった上位"),
                                        _createElementVNode("span", {
                                            textContent: _toDisplayString(_unref(showRankCount))
                                        }, null, 8, _hoisted_6),
                                        _createTextVNode("名の回答を選択してください。 ")
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(showRankCount) == 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 回答に対する評価を入力してください。 "))
                                    : _createCommentVNode("", true),
                                _hoisted_8,
                                _createTextVNode(" 次のようにメンターへ報酬が支払われます。 ")
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                (props.reward_amount.first_reward_amount)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                        _createVNode(ImageFrame, { src: `images/common/i_rank_1.svg` }, null, 8, ["src"]),
                                        _createElementVNode("span", null, _toDisplayString((_b = (_a = props.reward_amount.first_reward_amount) === null || _a === void 0 ? void 0 : _a.toLocaleString()) !== null && _b !== void 0 ? _b : 0), 1),
                                        _createTextVNode("円 ")
                                    ]))
                                    : _createCommentVNode("", true),
                                _hoisted_11,
                                (props.reward_amount.second_reward_amount)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                        _createVNode(ImageFrame, { src: "images/common/i_rank_2.svg" }),
                                        _createElementVNode("span", null, _toDisplayString((_d = (_c = props.reward_amount.second_reward_amount) === null || _c === void 0 ? void 0 : _c.toLocaleString()) !== null && _d !== void 0 ? _d : 0), 1),
                                        _createTextVNode("円 ")
                                    ]))
                                    : _createCommentVNode("", true),
                                _hoisted_13,
                                (props.reward_amount.third_reward_amount)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                        _createVNode(ImageFrame, { src: "images/common/i_rank_3.svg" }),
                                        _createElementVNode("span", null, _toDisplayString((_f = (_e = props.reward_amount.third_reward_amount) === null || _e === void 0 ? void 0 : _e.toLocaleString()) !== null && _f !== void 0 ? _f : 0), 1),
                                        _createTextVNode("円 ")
                                    ]))
                                    : _createCommentVNode("", true),
                                _hoisted_15,
                                ((_unref(showRankCount) != 1))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, "（各１回答づつ）"))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _createVNode(ImageFrame, {
                                                src: (_g = props.user) === null || _g === void 0 ? void 0 : _g.photo
                                            }, null, 8, ["src"])
                                        ]),
                                        _createElementVNode("div", _hoisted_21, _toDisplayString((_h = props.user) === null || _h === void 0 ? void 0 : _h.name), 1),
                                        _createElementVNode("div", _hoisted_22, _toDisplayString((_k = (_j = props.user) === null || _j === void 0 ? void 0 : _j.industry) === null || _k === void 0 ? void 0 : _k.name), 1),
                                        _createElementVNode("div", _hoisted_23, _toDisplayString((_l = props.question_type) === null || _l === void 0 ? void 0 : _l.name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(Formatter).formatCharOmit(props.subject)), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_25, _toDisplayString((_m = props.answer_count) === null || _m === void 0 ? void 0 : _m.toString()) + "名の回答", 1),
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(onSubmit, ["prevent"])
                            }, [
                                _createElementVNode("div", _hoisted_27, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mentors, (mentor, index) => {
                                        var _a, _b, _c;
                                        return (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("div", _hoisted_30, [
                                                    _createElementVNode("div", _hoisted_31, _toDisplayString((_a = mentor.user.industry) === null || _a === void 0 ? void 0 : _a.name), 1),
                                                    _createElementVNode("div", _hoisted_32, _toDisplayString((_c = (_b = mentor.user.job_group) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : 'その他'), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("div", {
                                                        class: "name",
                                                        onClick: ($event) => (onClickUserProfile(mentor.user.id))
                                                    }, _toDisplayString(mentor.user.name), 9, _hoisted_34),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _createVNode(ImageFrame, {
                                                            src: mentor.user.photo
                                                        }, null, 8, ["src"])
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(Formatter).formatCharOmit(mentor.answer.content, 300)), 1),
                                                _createElementVNode("div", _hoisted_38, [
                                                    _createElementVNode("div", _hoisted_39, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showRankCount), (rank) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                                                key: index + '-' + rank
                                                            }, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    "onUpdate:modelValue": ($event) => ((_unref(form).results[index].rank) = $event),
                                                                    value: rank,
                                                                    id: `rank_${index === null || index === void 0 ? void 0 : index.toString()}_${rank === null || rank === void 0 ? void 0 : rank.toString()}`,
                                                                    type: "radio",
                                                                    name: `rank_${index === null || index === void 0 ? void 0 : index.toString()}`
                                                                }, null, 8, _hoisted_40), [
                                                                    [_vModelRadio, _unref(form).results[index].rank]
                                                                ]),
                                                                _createElementVNode("label", {
                                                                    for: `rank_${index === null || index === void 0 ? void 0 : index.toString()}_${rank === null || rank === void 0 ? void 0 : rank.toString()}`,
                                                                    onClick: ($event) => (onClickRank(rank)),
                                                                    onDblclick: ($event) => (onClickResetRank(index))
                                                                }, [
                                                                    (rank === 1)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "金賞"))
                                                                        : _createCommentVNode("", true),
                                                                    (rank === 2)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, "銀賞"))
                                                                        : _createCommentVNode("", true),
                                                                    (rank === 3)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, "銅賞"))
                                                                        : _createCommentVNode("", true)
                                                                ], 40, _hoisted_41)
                                                            ], 64));
                                                        }), 128))
                                                    ]),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": ($event) => ((_unref(form).results[index].comment) = $event),
                                                        placeholder: "評価コメント",
                                                        id: `textarea_${index}`,
                                                        oninput: `resizeTextarea(${index},1)`,
                                                        onInput: onInputComment
                                                    }, null, 40, _hoisted_45), [
                                                        [_vModelText, _unref(form).results[index].comment]
                                                    ]),
                                                    (validate.shot && props.errors[`results.${index}.rank`])
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(props.errors[`results.${index}.rank`]), 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ]));
                                    }), 256))
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    (validate.shot && props.errors.message)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(props.errors.message), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                id: "submit-button",
                                                class: "bt_back",
                                                onClick: _withModifiers(onClickReturn, ["prevent"])
                                            }, " 戻る ", 8, _hoisted_49)
                                        ]),
                                        _hoisted_50
                                    ])
                                ])
                            ], 40, _hoisted_26)
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
